import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'

// Libs
import { useRouter } from 'next/router'
import { LiveListData } from '@/components/shared/LiveList/hooks/useLiveList'
import handleRoutePushWithQuery from '@/methods/url/handleRoutePushWithQuery'
import { handleGtmClickRoomListType } from '@/methods/handleGtmEvent'

// Components
import Icon from '@/assets/icons'
import TabButton from './components/TabButton'
import ActiveLives from '../Home/ActiveLives'
import VirtualizedLives from './components/VirtualizedLives'
import LiveSectionTitle from '@/components/pages/Home/utils/LiveSectionTitle'

// Methods

// Constants
import { liveTabsData } from '@/constants/liveRoom'
import { ROUTE_PATH } from '@/constants/routePath'
import { GTM_LOCATION } from '@/constants/gtmEvent'
import { useLiveList } from '@/components/shared/LiveList/hooks/useLiveList'
import { ROOM_LIVE_TYPE } from '@/constants/liveRoom'

// Styles
import styles from './style.module.scss'
import ProductScheduleButton from '@/components/shared/ProductScheduleButton'

const cx = classnames.bind(styles)

const Live = ({ liveDataSSR }: { liveDataSSR: LiveListData }) => {
  const router = useRouter()
  const { query } = router
  const { t } = useTranslation()

  const activeTabIndex = Number(query?.tab) || 0

  const liveListData = useLiveList({
    params: { pageSize: 20, liveTypes: [activeTabIndex === 0 ? ROOM_LIVE_TYPE.FUTURE : ROOM_LIVE_TYPE.PAST] },
    liveDataSSR,
  })

  const handleTabClick = (value: number[]) => {
    const activeIndex = liveTabsData.findIndex((item) => item.value === value)

    handleRoutePushWithQuery({ router, pathname: ROUTE_PATH.LIVE, query: { tab: activeIndex } })
  }

  return (
    <div className={cx('live')}>
      <div className={cx('container')}>
        <div className={cx('live__title')}>
          <div className={cx('live__title-left')}>
            {liveTabsData.map((tab: any, index: number) => (
              <TabButton
                key={index}
                handleCallback={() => {
                  handleTabClick(tab.value)
                  handleGtmClickRoomListType({ tabType: tab.gtmClickRoomListType, location: GTM_LOCATION.LIVE })
                }}
                selectedIndex={activeTabIndex}
                {...tab}
                index={index}
              />
            ))}
          </div>
          <div className={cx('live__title-right')}>
            <ProductScheduleButton />
          </div>
        </div>
        <div className={cx('live__content')}>
          {activeTabIndex === 0 && (
            <ActiveLives
              titleProps={{
                className: cx('live__title-active-lives-title'),
              }}
              className={cx('live__content-active-lives')}
            />
          )}
          {
            <VirtualizedLives
              liveListData={liveListData}
              title={activeTabIndex === 0 && <LiveSectionTitle icon={<Icon.ShopNotification />}>{t('Home_Upcoming_Lives')}</LiveSectionTitle>}
            />
          }
        </div>
      </div>
    </div>
  )
}

export default Live
